import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import Contract from './contract';
import Publish from './publish';
import { CONTRACT_VIEWED_KEY } from '../index';

const Content = observer<{
  data: any;
  type: string;
}>(({ data, type }) => {
  const [hasViewedContract, setHasViewedContract] = useState(
    localStorage.getItem(CONTRACT_VIEWED_KEY) === 'true'
  );
  const huhandleConsent = () => {
    // 用户同意合同后，记录到 localStorage
    localStorage.setItem(CONTRACT_VIEWED_KEY, 'true');
    setHasViewedContract(true);
  };

  return (
    <>
      {hasViewedContract ? (
        <Publish data={data} type={type} />
      ) : (
        <Contract huhandleConsent={huhandleConsent} />
      )}
    </>
  );
});
export default Content;
